export const state = {
    client_loading_status: null, // when waiting on api we set this true or false

    clients: [],
};

export const getters = {};

export const actions = {
    setClientsLoadingStatus({ commit }, value) {
        commit("setClientsLoadingStatus", value);
    },
    setClients({ commit }) {
        return new Promise((resolve, reject) => {
            commit("setClientsLoadingStatus", true);
            window.axios
                .get("api/collections/allclients")
                .then((response) => {
                    commit("setClients", response.data);
                    commit("setClientsLoadingStatus", false);
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },
};

export const mutations = {
    setClientsLoadingStatus(state, payload) {
        state.client_loading_status = payload;
    },
    setClients(state, payload) {
        state.clients = payload;
    },
};
